import TaxPayerInfoAPI from '@/api/TaxPayerInfoAPI.js';
import httpClient from './../../api/axios-httpclient';

export default {
	getTaxPayerInfo: async function(context, payload) {
		let res = await httpClient.getAsync(
			{
				url: TaxPayerInfoAPI.getAPIUrl() + '/info',
				params: payload
			},
			false,
			false
		);

		if (res && res.Success) {
			context.commit('setTaxPayerInfo', res.Data);
		}

		return res;
	},

	updateGuide: async function(context, payload) {
		let res = await httpClient.postAsync(
			{
				url: TaxPayerInfoAPI.getAPIUrl() + '/updateguide',
				data: payload
			},
			true
		);

		if (res && res.Success) {
			context.commit('updateViewGuide', true);
		}

		return res;
	},
	updateTaxPayerInfo: async function(context, payload) {
		let res = await httpClient.postAsync({
			url: TaxPayerInfoAPI.getAPIUrl() + '/update',
			data: payload
		});
		if (res && res.Data) context.commit('updateIsUpdateAdminArea', true);
		return res;
	},
	updateRemoteSigning: async function(context, payload) {
		context.commit('updateRemoteSigning', payload);
	},

	// Kiểm tra MST hiện tại có nằm trong tenant AMIS dùng chung cho nhiều MST khác không
	checkMultiTaxCode: async function(context) {
		let res = await httpClient.getAsync({
			url: TaxPayerInfoAPI.getAPIUrl() + '/checkmultitaxcode'
		});

		return res;
	},

	confirmTaxpayerType: async function(context, payload) {
		let res = await httpClient.postAsync(
			{
				url:
					TaxPayerInfoAPI.getAPIUrl() +
					`/confirm-type/${payload.taxpayerType}`
			},
			true
		);

		if (res && res.Success) {
			context.commit('setTaxPayerInfo', {
				...context.state.taxPayerInfo,
				TaxpayerInfoType: payload.taxpayerType,
				TaxpayerTypeConfirmed: true
			});
		}

		return res;
	}
};
